import React from "react"
import { Filter, FilterKey } from "../../Stats/Filtering/Filtering"

interface FiltersReactContext {
	filters: Filter[] | null
	addFilter: (key: FilterKey, value: string) => void
	removeFilter: (key: FilterKey) => void
	removeFilterValue: (key: FilterKey, value: string) => void
	rotateFilterKey: (key: FilterKey) => void
	setFilter: (key: FilterKey, values: string[]) => void
}

export const FiltersContext = React.createContext<FiltersReactContext | null>(null)

export function useFilters(): FiltersReactContext {

	const context = React.useContext(FiltersContext)
	if (!context) {
		throw new Error(`Filter is undefined in the context.`)
	}

	return context
}
